export const BRAND = {
  name: "Pop Panda",
  legal: "THE POP PANDA",
  retail: "POP PANDA GO",
  tagline: "Happiness on a Stick",
  hero: "Crafted Happiness, One Pop at a Time.",
  whatsappNumber: "918867566028",
  whatsappMessage: "Hi Pop Panda! 👋 I would like to know more about your products.",
  whatsappUrl:
    "https://wa.me/918867566028?text=" +
    encodeURIComponent("Hi Pop Panda! 👋 I would like to know more about your products."),
  logoUrl:
    "https://customer-assets.emergentagent.com/job_0c0ce025-fe36-4422-ae93-21a331f7f1fa/artifacts/7zz2hkza_IMG_4187.png",
  addresses: {
    manufacturing: {
      label: "Manufactured & Marketed by",
      line1: "THE POP PANDA",
      lines: [
        "Swiss Avenue Complex, Jantra",
        "Belman Post, Karkala Taluk",
        "Udupi District – 576111",
        "Karnataka, India",
      ],
    },
    retail: {
      label: "Retail Store",
      line1: "POP PANDA GO",
      lines: [
        "Below Bank of Baroda, Nitte",
        "Karkala Taluk",
        "Udupi District – 574110",
        "Karnataka, India",
      ],
    },
  },
};

export const CATEGORIES = [
  { key: "water", label: "Water-Based", blurb: "Light, refreshing, frozen pure fruit." },
  { key: "milk", label: "Milk-Based", blurb: "Smooth, satisfying, slow-set milk pops." },
  { key: "creamy", label: "Creamy Premium", blurb: "Rich, indulgent, single-origin ingredients." },
  { key: "zero_sugar", label: "Zero Sugar", blurb: "No added sugar. Natural sweeteners. Honest labels." },
  { key: "innovation", label: "Innovation Series", blurb: "Limited drops from our lab." },
  { key: "event", label: "Event & Bulk", blurb: "Curated boxes for weddings, schools, feasts." },
];

export const SWEETNESS = [
  { key: "none", label: "No Sugar" },
  { key: "low", label: "Low" },
  { key: "medium", label: "Medium" },
  { key: "sweet", label: "Sweet" },
];

export const SHAPES = [
  { key: "classic", label: "Classic Bar" },
  { key: "rocket", label: "Rocket" },
  { key: "twin", label: "Twin Stick" },
  { key: "heart", label: "Heart Pop" },
  { key: "moulded", label: "Moulded Round" },
];

export const PACKAGING = [
  { key: "minimal", label: "Minimal Eco-Wrap" },
  { key: "premium", label: "Premium Box" },
  { key: "gift", label: "Gift Sleeve" },
  { key: "festival", label: "Festival Edition" },
];

export const ADDONS = [
  "Sea Salt Flakes",
  "Belgian Chocolate Chips",
  "Roasted Pistachio",
  "Coconut Shavings",
  "Dehydrated Fruit Crisps",
  "Edible Rose Petals",
  "Honeycomb Bits",
  "Crunchy Granola",
  "Espresso Crumble",
];

export const STUDENT_AREAS = [
  "Marketing",
  "Branding",
  "Sales",
  "Content Creation",
  "Photography",
  "Videography",
  "Graphic Design",
  "Operations",
  "Food Production",
  "Business Development",
];
